<template>
  <div class="footer" id="footer">
    <div class="footer-top">
      <div class="footer-top-left">
        <h5>{{ isPc ? $t('foot1') : $t('footWap1') }}</h5>
        <img class="ewm" src="https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/ewm.png" alt="">
        <p :class="En ? 'en' : ''">{{ $t('foot2') }}</p>
        <ul v-if="isPc">
          <li @click="toWb"><img src="https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/wb.png" alt=""><img src="https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/wb-hover.png" alt="" class="hover"></li>
          <li @click="toXhs"><img src="https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/xhs.png" alt=""><img src="https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/xhs-hover.png" alt="" class="hover"></li>
        </ul>
        <ul v-else>
          <li @click="showEwm = true"><img src="https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/gzh.png" alt=""><span>{{ $t('footIcon1') }}</span></li>
          <li @click="toWb"><img src="https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/wb.png" alt=""><span>{{ $t('footIcon2') }}</span></li>
          <li @click="toXhs"><img src="https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/xhs.png" alt=""><span>{{ $t('footIcon4') }}</span></li>
        </ul>
      </div>
      <div class="footer-top-right">
        <div class="right-item" v-for="(item, index) in list" :key="index">
          <div class="title">{{ item['title' + En] }}</div>
          <div class="item" :class="!$route.name || $route.name === 'home' ? 'item-home' : ''" v-for="(ite, ind) in item.children" :key="index + 'c' + ind">
            <h3>{{ ite['title' + En] }}</h3>
            <p v-for="(it, i) in ite.children" @click="link(it)" :key="index + 'c' + ind + 'd' + i">{{ it['title' + En] }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">{{ $t('privacy') }}</div>
    <transition name="fade">
      <div class="foot-mask" v-if="!isPc && showEwm" @click="showEwm = false">
        <div class="foot-mask-content" @click.stop>
          <p>{{ $t('foot3') }}</p>
          <img class="ewm" src="https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/ewm.png" alt="">
          <p>{{ $t('foot2') }}</p>
          <img class="close" @click="showEwm = false" src="https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/close-icon.png" alt="">
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import protal from "@/api/protal"

export default {
  name: 'foot',
  data() {
    return {
      showEwm: false,
      list: []
    }
  },
  created() {
    protal.getJson('foot', data => {
        this.list = data
    })
  },
  methods: {
    link(item) {
      if (item.link && (!this.$route.name || this.$route.name === 'home')) {
        const offsetTop = $('#' + item.link).offset().top - 100
        $('html, body').animate({
            scrollTop: offsetTop
        }, 500);
      }
    },
    toWb() {
      window.open('https://weibo.com/u/7861219897', '_blank')
    },
    toXhs() {
      window.open('https://www.xiaohongshu.com/user/profile/5d7e60990000000001019536?xhsshare=CopyLink&appuid=5808338750c4b462dfeb1eed&apptime=1708484226', '_blank')
    },
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 768px) {
  .footer {
    padding: 63px 0 0 0;
    background: url(https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/foot-bg.jpg);
    background-size: 100% 100%;

    .footer-top {
      display: flex;
      justify-content: space-between;
      padding-bottom: 77px;
      padding-left: 168px;
      padding-right: 100px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
      width: 100%;

      .footer-top-left {
        position: relative;

        h5 {
          font-family: AlibabaPuHuiTi_3_65_Medium;
          font-size: 20px;
          color: #FFFFFF;
          line-height: 20px;
          text-align: left;
          font-style: normal;
        }

        .ewm {
          width: 152px;
          height: 152px;
          margin: 18px 0 10px;
        }

        p {
          font-family: AlibabaPuHuiTi_3_45_Light;
          font-size: 16px;
          color: rgba(255, 255, 255, 0.8);
          line-height: 16px;
          text-align: center;
          font-style: normal;

          &.en {
            text-align: left;
          }
        }

        ul {
          position: absolute;
          top: 160px;
          left: 175px;
          display: flex;
          
          li {
            margin-right: 25px;
            cursor: pointer;
            position: relative;

            img {
              width: 30px;
              height: 30px;
              transition: .3s;
            }

            .hover {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              opacity: 0;
              transition: .3s;
            }

            &:hover {
              img {
                opacity: 0;
              }

              .hover {
                opacity: 1;
              }
            }
          }
        }
      }

      .footer-top-right {
        display: flex;
        
        .right-item {
          width: 287px;

          .title {
            font-family: AlibabaPuHuiTi_3_65_Medium;
            font-size: 20px;
            color: #FFFFFF;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            margin-bottom: 28px;
          }

          .item {
            margin-bottom: 20px;
            
            h3 {
              font-family: AlibabaPuHuiTi_3_45_Light;
              font-size: 16px;
              color: #FFFFFF;
              line-height: 16px;
              text-align: left;
              font-style: normal;
            }

            P {
              font-family: AlibabaPuHuiTi_3_45_Light;
              font-size: 16px;
              color: rgba(255, 255, 255, 0.8);
              line-height: 16px;
              text-align: left;
              font-style: normal;
              margin-top: 12px;
            }
          }

          &:first-child {
            .item-home p:hover {
              cursor: pointer;
              color: #4D84FF;
            }
          }
        }
      }
    }

    .footer-bottom {
      text-align: center;
      font-family: AlibabaPuHuiTi_3_45_Light;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 22px;
      text-align: center;
      font-style: normal;
      padding: 28px 0 40px;
    }
  }
}
@media screen and (max-width: 1470px) and (min-width: 768px) {
  .footer {
    padding: 63px 0 0 0;
    background: url(https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/foot-bg.jpg);
    background-size: 100% 100%;

    .footer-top {
      display: flex;
      justify-content: space-between;
      padding-bottom: 77px;
      padding-left: 88px;
      padding-right: 50px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
      width: 100%;

      .footer-top-left {
        position: relative;

        h5 {
          font-family: AlibabaPuHuiTi_3_65_Medium;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 14px;
          text-align: left;
          font-style: normal;
        }

        .ewm {
          width: 122px;
          height: 122px;
          margin: 18px 0 10px;
        }

        p {
          font-family: AlibabaPuHuiTi_3_45_Light;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.8);
          line-height: 12px;
          text-align: center;
          font-style: normal;
        }

        ul {
          position: absolute;
          top: 130px;
          left: 145px;
          display: flex;
          
          li {
            margin-right: 16px;

            img {
              width: 24px;
              height: 24px;
            }
          }
        }
      }

      .footer-top-right {
        display: flex;
        
        .right-item {
          width: 187px;

          .title {
            font-family: AlibabaPuHuiTi_3_65_Medium;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            margin-bottom: 28px;
          }

          .item {
            margin-bottom: 16px;
            
            h3 {
              font-family: AlibabaPuHuiTi_3_45_Light;
              font-size: 14px;
              color: #FFFFFF;
              line-height: 14px;
              text-align: left;
              font-style: normal;
            }

            P {
              font-family: AlibabaPuHuiTi_3_45_Light;
              font-size: 14px;
              color: rgba(255, 255, 255, 0.8);
              line-height: 14px;
              text-align: left;
              font-style: normal;
              margin-top: 10px;
            }
          }

          &:first-child {
            .item p:hover {
              cursor: pointer;
              color: #4D84FF;
            }
          }
        }
      }
    }

    .footer-bottom {
      text-align: center;
      font-family: AlibabaPuHuiTi_3_45_Light;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 22px;
      text-align: center;
      font-style: normal;
      padding: 28px 0 40px;
    }
  }
}
@media screen and (max-width: 767px) {
  .footer {
    padding: 40px 0 0 0;
    background: url(https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/foot-bg.png);
    background-size: 100% 100%;

    .footer-top {
      width: 100%;

      .footer-top-left {
        position: relative;

        h5 {
          font-family: AlibabaPuHuiTi_3_65_Medium;
          font-size: 20px;
          color: #FFFFFF;
          line-height: 20px;
          padding-left: 18px;
          text-align: left;
          font-style: normal;
          font-weight: normal;
        }

        .ewm {
          display: none;
          width: 100px;
          height: 100px;
          margin: 16px auto 10px;
        }

        p {
          display: none;
          font-family: AlibabaPuHuiTi_3_45_Light;
          font-size: 16px;
          color: rgba(255, 255, 255, 0.8);
          line-height: 16px;
          text-align: center;
          font-style: normal;
        }

        ul {
          display: flex;
          margin: 20px 0 44px;
          padding-left: 11px;
          
          li {
            flex: 0 0 60px;

            img {
              width: 30px;
              height: 30px;
              margin: 0 auto 4px;
            }

            span {
              display: block;
              font-family: AlibabaPuHuiTi_2_45_Light;
              font-size: 11px;
              color: #FFFFFF;
              line-height: 20px;
              text-align: center;
              font-style: normal;
            }

            &:first-child {
              margin-right: 30px;
              position: relative;

              &::after {
                content: "";
                position: absolute;
                left: 75px;
                top: 0;
                bottom: 0;
                border-right: 1px solid rgba(255, 255, 255, 0.20);
              }
            }
          }
        }
      }

      .footer-top-right {
        
        .right-item {
          padding-left: 18px;
          margin-bottom: 30px;

          .title {
            font-family: AlibabaPuHuiTi_3_65_Medium;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            margin-bottom: 12px;
          }

          .item {
            margin-bottom: 10px;
            display: flex;
            
            h3 {
              font-family: AlibabaPuHuiTi_3_45_Light;
              font-size: 12px;
              color: #FFFFFF;
              line-height: 12px;
              text-align: left;
              font-style: normal;
              width: 80px;
            }

            P {
              font-family: AlibabaPuHuiTi_3_45_Light;
              font-size: 12px;
              color: rgba(255, 255, 255, 0.8);
              line-height: 12px;
              text-align: left;
              font-style: normal;
              margin-right: 12px;
            }
          }

          &:first-child {
            .item p:hover {
              cursor: pointer;
              color: #4D84FF;
            }
          }
        }
      }
    }

    .footer-bottom {
      text-align: center;
      font-family: AlibabaPuHuiTi_3_45_Light;
      font-size: 11px;
      color: rgba(255, 255, 255, 0.8);
      line-height: 16px;
      text-align: center;
      font-style: normal;
      padding: 20px 0.84rem 30px;
      width: 6.78rem;
      border-top: 1px solid rgba(255, 255, 255, 0.2);
      margin: 0 auto;
    }

    .foot-mask {
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.2);
      z-index: 99;
      display: flex;
      align-items: center;
      justify-content: center;

      .foot-mask-content {
        width: 5.6rem;
        height: 6.8rem;
        background: #FFFFFF;
        border-radius: 6px;
        padding-top: .76rem;
        position: relative;

        p {
          font-family: AlibabaPuHuiTi_3_65_Medium;
          font-size: 20px;
          color: #181818;
          line-height: 24px;
          text-align: center;
          font-style: normal;

          &:last-child {
            color: #666;
          }
        }

        .ewm {
          width: 4rem;
          margin: 20px auto 10px;
        }

        .close {
          position: absolute;
          width: .24rem;
          right: .38rem;
          top: .4rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue